import { size } from 'constants/device';
import { APP_ROUTES } from 'constants/routes';

import React from 'react';
import Link from 'next/link';
import Title from 'features/layout/components/Cards/common/Title';
import Picture from 'features/layout/components/Cards/common/Picture';
import { useWindowSize } from 'features/layout/hooks/useWindowSize';
import { useFavorite } from 'hooks/useFavorite';
import placeholder from '../../../../../public/assets/placeholders/placeholder-5.svg';

import Location from '../common/Location';
import Description from '../common/Description';

import { Props } from './types';
import {
  Container,
  InfoContainer,
  PriceAndPlaceContainer,
  Price,
} from './StudentHousingCard.styled';

const getHeight = (isMobile: boolean, isHorizontal: boolean): string => {
  if (isHorizontal) return '190px';
  return isMobile ? '90px' : '146px';
};

export const StudentHousingCard = ({
  title,
  description,
  photoURL,
  horizontal = false,
  objectID,
  city,
  price,
  slug,
}: Props) => {
  const [isFavorite, onFavoriteClick] = useFavorite('student_housing', objectID);
  const { width } = useWindowSize();
  const isMobile = width < size.tablet;
  const mainCity = Array.isArray(city) ? city[0] : city;
  const formattedPrice = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    maximumSignificantDigits: 5,
  }).format(price);
  return (
    <Link href={`${APP_ROUTES.STUDENT_HOUSING}/${slug}`} passHref>
      <a>
        <Container horizontal={horizontal}>
          <Picture
            src={photoURL}
            height={getHeight(isMobile, horizontal)}
            width={horizontal ? '271px' : '100%'}
            fit="cover"
            alt="Event"
            isFavorite={isFavorite}
            fallBackSRC={placeholder}
            onFavoriteClick={onFavoriteClick}
            loading="lazy"
          />
          <InfoContainer horizontal={horizontal}>
            <div>
              <Title maxLineCount={2}>{title}</Title>
              {horizontal && description && <Description maxLineCount={4} content={description} />}
            </div>
            <PriceAndPlaceContainer>
              {price && <Price>{price ? `${formattedPrice} p/m` : 'N/A'}</Price>}
              {mainCity && <Location name={mainCity} />}
            </PriceAndPlaceContainer>
          </InfoContainer>
        </Container>
      </a>
    </Link>
  );
};
